<template>
    <div
        class="w-100 h-100 tracker-widget position-relative"
        style="background-color:#cdcdcd; border-radius: 0 0 6px 6px;"
    >
        <div
            class="bg-white h-100 p-2 d-flex flex-column justify-content-start"
            style="background-color:#cdcdcd; border-radius: 0 0 6px 6px;"
        >
            <div class="d-flex justify-content-between align-center">
                <p class="mb-0">SOAP Note</p>
                <span class="ml-auto">
                    <a class="text-dark cursor-pointer" @click="closeTracker()">
                        <i class="fa fa-times mr-2"></i>
                    </a>
                </span>
            </div>

            <hr
                style="width:100%;margin: 0.5rem auto;color:#c3c3c3;background: #c3c3c3; height: 1px;"
            />

            <div class="p-3 variable-content">
                <p class="text-muted">
                    Session date:
                    {{ date ? moment(date).format("MM/DD/YYYY") : moment().format("MM/DD/YYYY") }}
                </p>

                <p class="mb-0 text-primary font-weight-bold text-uppercase">Subjective</p>
                <textarea
                    class="form-control form-control-sm subjective"
                    v-model="data.subjective"
                    name="description"
                    id="subjective"
                    rows="3"
                    placeholder="What the parent or child if they are old enough said how they are feeling"
                ></textarea>

                <p
                    v-if="!objectiveAssessment"
                    class="mb-0 mt-2 text-primary font-weight-bold text-uppercase"
                >
                    Objective
                </p>
                <p
                    v-if="objectiveAssessment"
                    class="mb-0 mt-2 text-primary font-weight-bold text-uppercase"
                >
                    Objective & Assessment
                </p>
                <textarea
                    class="form-control form-control-sm"
                    v-model="data.objective"
                    name="description"
                    id="objective"
                    rows="3"
                    :placeholder="
                        objectiveAssessment
                            ? 'The Objective is what you did during session and the Assessment is how the child responded to the Objective'
                            : 'What you did during session'
                    "
                ></textarea>

                <p
                    v-if="!objectiveAssessment"
                    class="mb-0 mt-2 text-primary font-weight-bold text-uppercase"
                >
                    Assessment
                </p>
                <textarea
                    v-if="!objectiveAssessment"
                    class="form-control form-control-sm"
                    v-model="data.assessment"
                    name="description"
                    id="assessment"
                    rows="3"
                    placeholder="How the child responded to the Objective"
                ></textarea>

                <p class="mb-0 mt-2 text-primary font-weight-bold text-uppercase">Plan</p>
                <textarea
                    class="form-control form-control-sm"
                    v-model="data.plan"
                    name="description"
                    id="plan"
                    rows="3"
                    placeholder="What is the plan for the next therapy visit"
                ></textarea>

                <div class="mt-3" v-show="user.signature">
                    <label for="signSoapNote">
                        <input type="checkbox" id="signSoapNote" v-model="data.is_signed" /> Sign
                        Soap Note
                    </label>
                    <img
                        id="signature"
                        v-if="data.is_signed && user.signature"
                        class="signatureWrapper"
                        :src="user.signature"
                        alt=""
                    />
                </div>
                <div v-show="!user.signature" class="mt-3">
                    <p>No signature found, please add it below to sign the Soap Note.</p>
                    <signature :user="user" :canvas-id="'tracker-soap'"></signature>
                </div>

                <div class="mt-3 mb-2">
                    <custom-signature
                        @cancel="caregiverSignatureCancelled"
                        @created="caregiverSignatureCreated"
                        :name="'Caregiver'"
                        :user="user"
                        :canvas-id="'tracker-soap-caregiver-sig'"
                    ></custom-signature>
                </div>

                <div class="my-2 w-100 d-flex">
                    <a
                        class="btn btn-sm btn-primary text-white text-uppercase font-weight-bold"
                        @click="saveTrackerData()"
                        >Save Tracking</a
                    >
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Signature from "../ui/Signature.vue";
import CustomSignature from "../ui/CustomSignature.vue";

export default {
    components: {
        CustomSignature,
        Signature,
    },
    name: "TrackerSoap",
    props: ["patientId", "sessionGoals", "date", "sessionNotes", "customization", "user"],
    data() {
        return {
            data: {
                subjective: "",
                objective: "",
                assessment: "",
                plan: "Continue plan of care",
            },
            objectiveAssessment: false,
        };
    },

    created() {
        if (this.sessionGoals) {
            this.data.objective += this.sessionGoals.reduce(
                (acc, cur, idx, src) => acc + cur.description + (idx === src.length ? "" : " - "),
                ""
            );
        }
        if (this.sessionNotes) {
            this.data.assessment += this.sessionNotes;
        }
        if (this.objectiveAssessment) {
            this.data.objective += this.data.assessment;
        }
    },

    mounted() {
        if (
            this.customization &&
            this.customization.default_options &&
            this.customization.default_options.plan
        ) {
            this.data.plan = this.customization.default_options.plan;
        }
    },

    methods: {
        closeTracker() {
            this.$emit("close-soap");
        },

        saveTrackerData() {
            this.data.session_at = this.date
                ? this.moment(this.date).format("YYYY-MM-DD HH:mm:ss")
                : this.moment().format("YYYY-MM-DD HH:mm:ss");
            axios
                .post(`/api/patients/${this.patientId}/soap_notes`, this.data)
                .then(r => {
                    this.$emit("close-soap");
                })
                .catch(e => {
                    this.$swal({
                        title: "Error!",
                        text: "An error occurred while saving.",
                        type: "error",
                        confirmButtonText: "Close",
                        confirmButtonColor: "#d64571",
                    });
                    console.error(e);
                });
        },

        caregiverSignatureCreated(signature_url) {
            this.data.caregiver_signature = signature_url;
        },

        caregiverSignatureCancelled() {
            this.data.caregiver_signature = null;
        },
    },
};
</script>

<style scoped lang="scss">
.subjective::placeholder {
    font-style: italic;
    color: lightgray;
}
#signature {
    border: 1px solid lightgray;
}
</style>
